define('default-controller',['angular-storage',
    'default-ui',
    'default-resource',
    'default-service',
    'i18n-provider',
    'dashboard-controller',
    'dashboard-resource',
    'contato-controller',
    'contato-resource',
    'campanhas-controller',
    'campanhas-resource',
    'pagina-controller',
    'pagina-resource',
    'imovel-controller',
    'imovel-resource',
    'imovelcliente-controller',
    'imovelcliente-resource',
    'imovelusuario-controller',
    'imovelusuario-resource',
    'usuario-default-controller',
    'mapa-imoveis-resource',
    'mapa-imoveis-controller',
    'angular-diretivas-site',
    'angular-socialshare',
    'angular-lightslider',
    "angular-recaptcha",
    'angular-socialshare',
    'angular-ui-select',
    'lg-video',
    'angularmap',
    'angular-input-masks',
    "anchor-service",
    "angular-datepicker",
    "jspdf",
    "qrcode-angular",
    "lodash416"
], function() {

    var app = angular.module('default.controller', [
        'ngStorage',
        'default.ui',
        'default.resource',
        'default.service',
        'djds4rce.angular-socialshare',
        'angular-diretivas-site',
        'angular.lightslider',
        'dashboard.controller',
        'contato.controller',
        'imovelcliente.controller',
        'imovelusuario.controller',
        'campanhas.controller',
        'pagina.controller',
        'imovel.controller',
        'mapa.imoveis.controller',
        'usuario.default.controller',
        'i18n.provider'
    ]);

    app.controller('DefaultController', ['$rootScope', '$i18n', '$scope',  '$defaultUI', 'Default', "currency",  '$anchorScroll', 'tmhDynamicLocale', '$location', '$window', "$FB", "$localStorage", "$sessionStorage", "$timeout", "$filter",
        function($rootScope, $i18n, $scope, $defaultUI, Default, currency,  $anchorScroll, tmhDynamicLocale, $location, $window, $FB, $localStorage, $sessionStorage, $timeout, $filter) {
            $rootScope.loaded = false;
            $rootScope.usuarioLogado = usuarioLogado;
            $rootScope.$watch('$viewContentLoaded', function(){
                $rootScope.loaded = true;
            });

            $rootScope.i18n = $i18n.dict;

            // Ruggini - Modelo 06
            $scope.currentYear = new Date().getFullYear();

            $scope.searchActive = false;

            $scope.toggleHeaderSearch = function(){
                $scope.searchActive = $scope.searchActive ? false : true;
            }

            // RUGGINI 15/02/17 - MODELO 5 DESKTOP MENU
            $scope.clickMenu = function(){
                $scope.menuDesktop = $scope.menuDesktop ? false : true;
            }

            $scope.toggleMenu = function(){
                $scope.menuActive = !$scope.menuActive;
            }

            // Busca Modelo VidaPrime
            $scope.toggleSearch = function(){
                $scope.searchActive = !$scope.searchActive;
            }
            $scope.toggleSearch2 = function(){
                if($('#drop-search').hasClass('hide')){
                    $('#drop-search').removeClass('hide');
                    $('#drop-search').addClass('show');
                }
                else if($('#drop-search').hasClass('show')){
                    $('#drop-search').removeClass('show');
                    $('#drop-search').addClass('hide');
                }
            }

            // Busca Modelo VidaPrime

            $(window).scroll(function() {
                if ($(this).scrollTop() == 0) {
                    $('header').removeClass('scrolled');
                }
                if ($(this).scrollTop() > 0) {
                    $('header').addClass('scrolled');
                }
            });

            $(".site-content-wrap").addClass('loading-wrap');

            // $scope.rugginiPermite = true;

            $scope.gotoTop = function() {
                $location.hash('top');
                $anchorScroll();
            };
            $rootScope.gotoTop = function() {
                $location.hash('top');
                $anchorScroll();
            };
            $scope.showFavorites = false;

            $scope.openFav = function(){
                $scope.showFavorites = $scope.showFavorites ? false : true;
            }

            $scope.getQtdMaior = function(obj){
                var aux = false;
                if(Array.isArray(obj.sub_tipo)){
                    obj.sub_tipo.map(function(el, idx){
                        if(el.ist_qtd > 0){
                            aux = true;
                        }
                    });
                }
                return aux;
            };
            $scope.MobileMenu = false;

            $scope.openMenu = function(){
                $scope.MobileMenu = $scope.MobileMenu ? false : true;
                $scope.showMenu = false;
                $scope.operacao = {ttpr_codigo:0, ttpr_nome:null};
            }

            // Botão Subir para o topo

            $scope.goTop = function(){
                $("html, body").animate({ scrollTop: 0 }, "slow");
            };

            // MenuMobile

            // Hide Header on on scroll down

            var didScroll;
            var delta = 3;
            // var navbarHeight = $('main').outerHeight();
            var mainTop = $('main').offset().top;

            $(window).scroll(function(event){
                didScroll = true;
            });

            setInterval(function() {
                if (didScroll) {
                    hasScrolled();
                    didScroll = false;
                }
            }, 300);

            function hasScrolled() {
                var st = $(this).scrollTop();

                // Make sure they scroll more than delta

                if ( st > mainTop){
                    $('#fixed-bar').addClass('nav-up');
                } else {
                    if(st < mainTop) {
                        $('#fixed-bar').removeClass('nav-up');
                    }
                }
            };


            var metaLanguage = angular.element('meta[name="language"]');
            tmhDynamicLocale.set(metaLanguage[0].content);
            $scope.fadeOutDestaqueModal = function(){
                $scope.showMenu = false;
            }
            $scope.socialMedias = [];
            $scope.showMenu = false;
            $scope.operacao = {ttpr_codigo:0, ttpr_nome:null};
            $scope.changeShowMenu = function(bool, ttpr_codigo, ttpr_nome){
                $scope.showMenu = bool;
                $scope.MobileMenu = false;

                // alert(ttpr_nome);

                $scope.operacao.ttpr_codigo = ttpr_codigo;
                $scope.operacao.ttpr_nome = ttpr_nome;
                $scope.getTipoCadastroFiltro();
            }
            $scope.tipoCadastro = [];
            $scope.getTipoCadastroFiltro = function(){
                if($scope.operacao.ttpr_codigo !== null) {
                    Default.getTipoCadastroFiltro($scope.operacao.ttpr_codigo).then(function (results) {
                        $('#menu-carousel, #menu-desktop__carousel').find('li').each(function(idx, el){
                            $('#menu-carousel, #menu-desktop__carousel').trigger("removeItem", el)
                        });
                        $scope.tipoCadastro = angular.copy(results).filter(op => {
                            if (op.sub_tipo && Array.isArray(op.sub_tipo)) {
                                op.sub_tipo = op.sub_tipo.filter(op2 => op2.ist_qtd > 0);
                            }
                        
                            return op.sub_tipo && op.sub_tipo.length > 0;
                        });
                        
                        var config = {
                            direction : "left",
                            auto: true,
                            prev: {
                                button: function() {
                                    return $("#menu-carousel, #menu-desktop__carousel").parent().parent().siblings(".prev");               }
                            },
                            next: {
                                button: function() {
                                    return $("#menu-carousel, #menu-desktop__carousel").parent().parent().siblings(".next");
                                }
                            },
                            width     : $("#menu-carousel, #menu-desktop__carousel").width(),
                            height    : $("#menu-carousel, #menu-desktop__carousel").height(),
                            responsive: "true",
                            items     : {
                                visible: {
                                    min: 1,
                                    max: 4
                                }
                            },
                            scroll    : {
                                pauseOnHover: true,
                                items   : 1,
                                fx      : 'scroll',
                                duration : 1000
                            },
                            onCreate : function () {
                                $('.menu-list-column').show();
                            }
                        };
                        setTimeout(function () {
                            $("#menu-carousel, #menu-desktop__carousel").carouFredSel('destroy');
                            $("#menu-carousel, #menu-desktop__carousel").carouFredSel(config);
                        }, 0);
                    });
                }
            }
            $scope.aditionalPhones = [];
            $scope.aditionalEmails = [];
            $scope.indices = [];
            $scope.indSelected = 0;
            $scope.indSelect= function ($index) {
                $scope.indSelected = $index;
            };
            $scope.imgTopo = '';
            $scope.placeholderpesquisa = 'Apartamento 2 dorm';
            $scope.default = {
                buscaroot:  null,
                buscarootCodigo:null
            }
            $scope.getBusca = function(){
                if($scope.default.buscaroot != null && $scope.default.buscaroot != ''){
                    var busca = $scope.default.buscaroot;
                    if (!isNaN(busca))  window.location = 'imovel/?filter='+parseInt(busca)+'&onlycod=true';
                    else window.location = 'imovel/?filter='+busca;// $location.url('imovel/?filter='+busca)
                }
            };

            $scope.navigateToMapa = function(){
                window.location = 'mapa-imoveis';
            };

            $scope.getBuscaCodigo = function(){
                if($scope.default.buscarootCodigo != null && $scope.default.buscarootCodigo != ''){
                    var busca = $scope.default.buscarootCodigo;
                    if (!parseInt(busca)) alert('Informe um número!');
                    else window.location = 'imovel/?filter='+parseInt(busca)+'&onlycod=true';
                }
            };
            $scope.svgIcons = 'uploads/html/svgIcons.html';
            $scope.clickBtnLogin = function(){
                $scope.loginButton = true;
            }
            $scope.fb = false;
            $scope.FBLogin = function(){
                FB.login(function(auth){
                    if(auth.authResponse){
                        FB.api('/me', {fields: 'name, email'},function(response){
                            if(response.name && response.email){
                                // tokenfacebook, idfacebook, nome, email
                                Default.checkLoginFacebook({tokenfacebook:auth.authResponse.accessToken,
                                    idfacebook:response.id, nome:response.name, email:response.email}).then(function(result){
                                    $localStorage.token = result.token;
                                    $rootScope.usuarioLogado = result.data;
                                    $window.location.reload();
                                    //   console.log($rootScope.usuarioLogado);
                                });
                            }
                        });
                    }else{
                        // console.log('opa');
                    }
                }, {scope:'public_profile,email'});
            };
            /*
             Usuario Logado
             Aqui Sao funcoes que serao realizadas pelo usuario logado
             */
            /*
             Login E cadastro
             */
            //$rootScope.usuarioLogado = false;
            $scope.menuSuspenso = false;
            $scope.formAtual = 'login';
            $scope.formName = 'Acesse sua conta';
            $rootScope.logout = function(){
                Default.logout().then(function(r){
                    $localStorage.$reset();
                    $window.location = '/';
                });

            }
            $scope.resetLogin = function(){
                $scope.login = {
                    email:null,
                    password:null
                }
            }
            $scope.resetLogin();
            $scope.msgErrorLogin = false;
            $scope.loginFn = function(formLogin){
                if(formLogin.$valid){
                    Default.checkLogin($scope.login).then(function(result){
                        if(result.data) {
                            window.location.reload();
                            $localStorage.token = result.token;
                           // $rootScope.usuarioLogado = result.data;
                            $scope.msgErrorLogin = false;
                        }else{
                            $scope.msgErrorLogin = 'Usuário ou senha incorretos';
                            setTimeout(function(){
                                $scope.$apply(function(){
                                    $scope.msgErrorLogin = false;
                                });
                            }, 5000);
                        }
                    });
                }
                else {
                    angular.forEach(formLogin.$error.required, function (value, key) {
                        formLogin.$error.required[key].$pristine = false;
                    });
                }
            };
            /*
             IMPORTANTE FUNCAO QUE RELOAD NO USUARIO LOGADO PEGANDO AS NOVAS COISAS QUE FORAM FEITAS
             */
            $rootScope.reloadUsuarioLogado = function(){
                if($rootScope.usuarioLogado){
                    Default.reloadUsuarioLogado().then(function(result){
                        $localStorage.token = result.token;
                        $rootScope.usuarioLogado = result.data;
                        // console.log($rootScope.usuarioLogado);
                    });
                }
            }
            $scope.changeForm = function(form, name){
                $scope.formAtual = form;
                $scope.formName = name;
            }
            $scope.resetNewCad = function(){
                $scope.cadastro = {
                    nome:null,
                    email:null,
                    telefone:null
                }
            }
            $scope.resetNewCad();
            $scope.newCad = function(formNewCad) {
                if (formNewCad.$valid) {
                    Default.newCad($scope.cadastro).then(function(result){
                        if(result.error){
                            alert(result.msg);
                        return;
                        }
                        
                        if(result.data) {
                            window.location.reload();
                            $localStorage.token = result.token;
                            $scope.msgErrorLogin = false;
                            alert('Seu cadastro foi criado com sucesso, acesse a Área do cliente e altere sua senha assim que possível.');

                        }else{
                            $scope.msgErrorLogin = 'Não foi possível completar seu cadastro';
                            setTimeout(function(){
                                $scope.$apply(function(){
                                    $scope.msgErrorLogin = false;
                                });
                            }, 5000);
                        }
                    });
                }  else {
                    angular.forEach(formNewCad.$error.required, function (value, key) {
                        formNewCad.$error.required[key].$pristine = false;
                    });
                }
            }
            $scope.resetRecuperar = function(){
                $scope.recuperar = {
                    email:null
                }
            };
            $scope.resetRecuperar();
            $scope.resetPassword = function(fromResetPassword){
                if (fromResetPassword.$valid) {
                    Default.resetPassword($scope.recuperar).then(function(result){
                        if(result.confirm){
                            fromResetPassword.$setPristine();
                            $scope.resetRecuperar();
                            alert(result.msg);
                        }else{
                            alert(result.msg);
                        }
                    });
                }  else {
                    angular.forEach(fromResetPassword.$error.required, function (value, key) {
                        formNewCad.$error.required[key].$pristine = false;
                    });
                }
            }
            /*
             Imoveis Favoritos
             */
            $rootScope.addImovelFavorito = function(imo_codigo, callBack){
                Default.addImovelFavorito({imo_codigo:imo_codigo}).then(function(result){
                    if(result.success){
                        $rootScope.reloadUsuarioLogado();
                        if(callBack){
                            callBack();
                        }
                        return true;
                    }
                })
            }
            $rootScope.checkImovelFavorito = function(imo_codigo){
                if($rootScope.usuarioLogado){
                    var find = _.find($rootScope.usuarioLogado.ImoFavoritos, function(o){return o.imo_codigo == imo_codigo});
                    if(find){
                        return true;
                    }else{
                        return false;
                    }
                }
            }
            // fim imoveis favoritos
            //===============================================================================
            $rootScope.formatTel = function(tel){//seprecisar
                var prefix = tel.substr(0 ,2);
                var telreset = tel.substr(2, tel.length);
                return '<span class="prefix">'+prefix+'</span>'+telreset;
            }
            /*
             Ruggine
             */
            $scope.formatIndice = function(data, valor){
                valor = $filter('currency')(valor,"");
                data = $filter('date')(data, "MMMM");
                return data + ' &nbsp <span class="number fw-400">' + valor + '%</span>'
            }

            /*
             Pega do Session Se ja foi respondido tal formulario
             10 minutos
             */
            $rootScope.responseForm = function(imo_codigo){
                var expirationMS = 10 * 60 * 1000;
                var record = {value: imo_codigo, timestamp: new Date().getTime() + expirationMS}
                if($localStorage.formResponse == null){
                    $localStorage.formResponse = [];
                    $localStorage.formResponse.push(record);
                }else{
                    $localStorage.formResponse.push(record);
                }
            }
            $rootScope.checkResponse = function(imo_codigo){
                var arr = $localStorage.formResponse;
                var aux = false;
                if(arr != null) {
                    for (var i = 0; i < arr.length; i++) {
                        if (arr[i] != null && new Date().getTime() < arr[i].timestamp && arr[i].value == imo_codigo) {
                            aux = true;
                        }else{
                            if(arr[i].value == imo_codigo) {
                                $localStorage.formResponse.splice(i, 1);
                            }
                        }
                    }
                }
                return aux;
            }
            //=====================================================
            // console.log($localStorage.formResponse);
            /*

                     - Newletter

             */
            $scope.resetNewsLetter = function(){
                $scope.newsletter = {emailnewsletter:null}
            }
            $scope.resetNewsLetter();
            $scope.saveEmailNews = function(formNewsLetter){
                if(formNewsLetter.$valid){
                    Default.saveEmailNews({email:$scope.newsletter.emailnewsletter}).then(function(result){
                        if(result.success){
                            alert(result.msg);
                            $scope.resetNewsLetter();
                            //$mdDialog.alert().title('Atenção!')
                        }
                    });
                }
            }

            /** Motar Objeto que Para o filtro */
            $scope.dataFiltroAv = {
                tipolocacao : '',
                intervalos  : '',
                tipofiltro  : '',
                subTipo     : '',
                cidade      : '',
                bairro      : '',
                condominio  : '',
                codigo  : '',
            }
            $scope.dataIndex = function() {
                Default.dataIndex().then(function(result){
                    $scope.filtros = result.filtros
                });
            }

            $scope.getblPreco = function(data){
                if (data != ''){
                    $scope.filteredByNames = $filter('filter')($scope.filtros.tblpreco, {ttpr_codigo: data});
                    $scope.valueFiltered = $scope.filteredByNames;
                    $scope.tipo =  $scope.valueFiltered[0].intervalos;
                }else{
                    $scope.tipo = [];
                }
            }

            $scope.getsuTipoFiltro = function(data){
                if (data != ''){
                    $scope.filteredByNames = $filter('filter')($scope.filtros.tipoCadastro, {tic_codigo: data});
                    $scope.valueFiltered = $scope.filteredByNames;
                    $scope.subTipofitro =  $scope.valueFiltered[0].ImovelSubtipo;
                }else{
                    $scope.subTipofitro = [];
                }
            }

            $scope.dataIndex();

            $scope.pesquisaBairro = function(data) {
                if (data != '') {
                    Default.getBairro(data, '').then(function(bairros) {
                        $scope.bairros = bairros;
                    });
                }else{
                    $scope.bairros = [];
                }
            }

            $scope.buscaAvancado = function(vl){
                console.log(vl);
                var tipof = $scope.dataFiltroAv.tipofiltro;
                if ($scope.dataFiltroAv.subTipo){
                    $scope.subtp = '&subtipoimovel='+$scope.dataFiltroAv.subTipo;
                }else{
                    $scope.subtp = '';
                }

                var cida = $scope.dataFiltroAv.cidade;
                var cond = $scope.dataFiltroAv.condominio;

                if ($scope.dataFiltroAv.bairro){
                    $scope.bairr = '&bairros='+$scope.dataFiltroAv.bairro;
                }else{
                    $scope.bairr = '';
                }

                if ($scope.dataFiltroAv.codigo){
                    $scope.codigo = '&codigo='+$scope.dataFiltroAv.codigo;
                }else{
                    $scope.codigo = '';
                }

                if ($scope.dataFiltroAv.tipolocacao){
                    $scope.operacaoFiltro = $scope.dataFiltroAv.tipolocacao;
                }else{
                    $scope.operacaoFiltro = '';
                }
                if ($scope.dataFiltroAv.intervalos != ''){
                    $scope.valor = JSON.parse($scope.dataFiltroAv.intervalos);
                    $scope.max = $scope.valor.max.toFixed(2);
                    $scope.min = $scope.valor.min.toFixed(2);
                }else{
                    $scope.max = '';
                    $scope.min = '';
                }
                window.location = 'imovel?operacao='+$scope.operacaoFiltro+
                    '&tipoimovel='+tipof+$scope.subtp+'&empreendimento='+cond+'&destaque=false&vlini='+$scope.min+
                    '&vlfim='+$scope.max+'&exclusivo=false&cidade='+cida+'&limit=9&page=0'+$scope.bairr+
                    '&ttpr_codigo='+$scope.operacaoFiltro+$scope.codigo;
            }
            /** */

            $scope.insertSubType = function(subTypeObj, type){
                    $scope.subTypeObj = angular.copy(subTypeObj);
                    $scope.typeObj = {tic_nome:type.tic_nome, tic_codigo:type.tic_codigo};
            }
            $scope.resetSubType = function(){
                $scope.subTypeObj = [];
                $scope.typeObj = {}
            }
            $scope.resetSubType();

            $scope.verificaItensSubtipo = function(subtipos) {
                var show = false;
                _.forEach(subtipos, function(subTipo){
                    if (subTipo.ist_qtd > 0) show = true;
                });

                return show;
            };

            //templete 6 gamb
            $scope.rowStyle = "";
            $scope.calcRow = function(index) {
                $scope.rowStyle = "";
                if(index % 6 == 0 && index > 4){ // numero de colunas 6, ao preencher 6 colunas add row layout pra jogar itens para baixo e não ficar espremido
                    $scope.rowStyle = "layout-row";
                }
                return true;
            };

            $rootScope.getTemplate = function() {
                return new Promise(function(resolve, reject) {
                    Default.getTemplate().then(function(result) {
                        resolve(result.template);
                    }).catch(function(error) {
                        reject(error);
                    });
                });
            };

            if(chat) {
                var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date();
                (function () {
                    var s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
                    s1.async = true;
                    s1.src = 'https://embed.tawk.to/'+par_chat+'/default';
                    s1.charset = 'UTF-8';
                    s1.setAttribute('crossorigin', '*');
                    s0.parentNode.insertBefore(s1, s0);
                })();
            }
            

        }
    ]);
    app.directive('ngMatch', ['$parse', function ($parse) {

        var directive = {
            link: link,
            restrict: 'A',
            require: '?ngModel'
        };
        return directive;

        function link(scope, elem, attrs, ctrl) {
            if (!ctrl) return;
            if (!attrs['ngMatch']) return;
            var firstPassword = $parse(attrs['ngMatch']);
            var validator = function (value) {
                var temp = firstPassword(scope),
                    v = value === temp;
                ctrl.$setValidity('match', v);
                return value;
            }
            ctrl.$parsers.unshift(validator);
            ctrl.$formatters.push(validator);
            attrs.$observe('ngMatch', function () {
                validator(ctrl.$viewValue);
            });
        }
    }]);
    app.controller('ResetAccountController', ['$rootScope', '$scope',  '$defaultUI', 'Default', "currency", "$metadata", "$stateParams",
        function($rootScope, $scope,  $defaultUI, Default, currency, $metadata, $stateParams) {
            $scope.checkToken = function(){
                var obj = {
                    token:$stateParams.token
                }
                Default.checkToken(obj);
            };
            $scope.checkToken();
            $scope.reset = function(){
                $scope.formulario = {
                    senha:null,
                    senha2:null
                }
            }
            $scope.reset();
            $scope.msgSuccess = false;
            $scope.msgError = false;
            $scope.$try = false;
            $scope.resetPassword = function(form){
                if (form.$valid) {
                    $scope.$try = false;
                    console.log($scope.formulario.senha);
                    var obj = {
                        token:$stateParams.token,
                        senha:$scope.formulario.senha
                    }
                    Default.resetPasswordvalid(obj).then(function(result){
                        console.log(result)
                        if(result.success){
                            $scope.msgSuccess = 'Senha alterada com sucesso!';
                        }else{
                            $scope.msgError = 'Ocorreu um erro na alteração!';
                        }
                    })
                }else{
                    $scope.$try  = true;
                    angular.forEach(form.$error.required, function(value, key){
                        form.$error.required[key].$pristine = false;
                    });
                }
            }
        }]);
});

